import React from 'react';
import { withRouter } from 'react-router-dom';
import AdSenseUnit from './AdSenseUnit';
import { AD_SLOTS } from '../../utils/adsense';

/** Manual in-content ad on editorial pages — uses AD_SLOTS.article when set. */
function ContentAdSlot({ className = 'adsense-unit--in-content container', layout = 'article', location }) {
	return (
		<AdSenseUnit
			slot={AD_SLOTS.article}
			className={className}
			layout={layout}
		/>
	);
}

export default withRouter(ContentAdSlot);
